import gsap, { Power2 } from 'gsap';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

class ScrollItem__ProjectList extends ScrollItem__BlockDefault {
  _filters;
  _projects;

  _click = (e) => this.filter(e);
  _enter = (e) => this.hoverIn(e);
  _leave = (e) => this.hoverOut();

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);

    this._filters = GetBy.class('__filter', __link);
    this._projects = GetBy.class('__project', __link);

    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].addEventListener(Basics.clickEvent, this._click);
    }

    if (!isTouch) {
      for (let i = 0; i < this._projects.length; i++) {
        this._projects[i].addEventListener(Basics.mouseOver, this._enter);
        this._projects[i].addEventListener(Basics.mouseOut, this._leave);
      }
    }
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  filter(e) {
    const btn = e.target;

    if (btn.classList.contains('--active')) btn.classList.remove('--active');
    else btn.classList.add('--active');

    const filters = [];
    for (let i = 0; i < this._filters.length; i++) {
      const f = this._filters[i];

      if (f.classList.contains('--active')) {
        filters.push(f.dataset.categ);
      }
    }

    for (let i = 0; i < this._projects.length; i++) {
      const p = this._projects[i];
      p.classList.remove('--active');

      for (let i = 0; i < filters.length; i++) {
        const filter = `categ-${filters[i]}`;

        if (p.classList.contains(filter)) {
          p.classList.add('--active');
        }
      }
    }
  }

  hoverIn(e) {
    for (let i = 0; i < this._projects.length; i++) {
      const p = this._projects[i];

      if (p !== e.target) {
        p.classList.add('--hover-out');
      } else {
        p.classList.add('--hover-in');
      }
    }
  }

  hoverOut() {
    for (let i = 0; i < this._projects.length; i++) {
      const p = this._projects[i];
      p.classList.remove('--hover-out');
      p.classList.remove('--hover-in');
    }
  }

  dispose() {
    super.dispose();
    for (let i = 0; i < this._filters.length; i++) {
      this._filters[i].removeEventListener(Basics.clickEvent, this._click);
    }

    if (!isTouch) {
      for (let i = 0; i < this._projects.length; i++) {
        this._projects[i].removeEventListener(Basics.mouseOver, this._enter);
        this._projects[i].removeEventListener(Basics.mouseOut, this._leave);
      }
    }
  }
}

Scroll._registerClass('project-list', ScrollItem__ProjectList);